<div class="grid-list__grid" [ngStyle]="gridStyles">
  <ng-content></ng-content>
</div>
